import Vue from "vue";
import App from "./App.vue";
import Podcasts from "@/components/Podcasts.vue";
import Podcast from "@/components/Podcast.vue";
import PodcastsPaged from "@/components/Podcasts.vue";

Vue.config.productionTip = false;

Vue.filter('formatDate', function(dt){
  if (dt && dt.indexOf("T")>=0) return dt.split("T")[0]
})

import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router= new VueRouter({
  mode:'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/page/:p',
      name: 'home2',
      component: Podcasts,
    },
    {
      path: '/',
      name: 'home',
      component: Podcasts,
    },

    {
      path: '/shows/:id',   // Route with id parameter
      name: 'show',
      component: Podcast
    },
    {
      path: '*',
      name: 'notFound',
      component: Podcasts, // Catch-all route
      
    }
  ],
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");


